import React, { FC } from 'react';

import ChevronIcon from 'components/common/icons/ChevronIcon';

interface PaginationProps {
  perPage: number;
  currPage: number;
  totalCount: number;
  onPageChange: (page: number) => void;
}

/**
 * @param param0
 * @returns
 */
const Pagination: FC<PaginationProps> = ({ perPage, currPage, totalCount, onPageChange }) => {
  if (totalCount === null || totalCount === undefined) {
    return null;
  }

  const pagesCount = Math.ceil(totalCount / perPage);

  const handlePageChange = (page: number): void => {
    if (page > 0 && page <= pagesCount) {
      onPageChange(page);
    }
  };

  const renderPageButtons = (): any => {
    const buttons = [];
    let startPage = Math.max(1, currPage - 1);
    let endPage = Math.min(pagesCount, currPage + 1);

    if (currPage === 1) {
      endPage = Math.min(pagesCount, 3);
    } else if (currPage === pagesCount) {
      startPage = Math.max(1, pagesCount - 2);
    }

    for (let i = startPage; i <= endPage; i++) {
      buttons.push(
        <button
          key={i}
          type="button"
          className={`${
            currPage === i ? 'tw-bg-primary tw-text-white' : ''
          } tw-mx-[2px] tw-h-8 tw-w-8 tw-rounded-lg tw-p-2`}
          onClick={(): void => handlePageChange(i)}
        >
          {i.toLocaleString()}
        </button>
      );
    }
    return buttons;
  };

  return (
    <div className="tw-mt-4 tw-flex tw-flex-row tw-items-center tw-justify-end">
      <div className="tw-mr-4 tw-text-primary-grey">
        {(perPage * (currPage - 1) + 1).toLocaleString()} -{' '}
        {Math.min(perPage * currPage, totalCount).toLocaleString()} of {totalCount.toLocaleString()}
      </div>

      {currPage > 1 && (
        <button
          type="button"
          onClick={(): void => handlePageChange(currPage - 1)}
          className="tw-px-0"
        >
          <ChevronIcon direction="left" />
        </button>
      )}

      {renderPageButtons()}

      {currPage < pagesCount && (
        <button
          type="button"
          onClick={(): void => handlePageChange(currPage + 1)}
          className="tw-px-0"
        >
          <ChevronIcon direction="right" />
        </button>
      )}
    </div>
  );
};

export default Pagination;
